import { AlkLogger } from '@alk/core';
import { ExtractionResult, ExtractionSelector } from '../../interfaces/functions.interface';
import { injectable } from 'inversify';
import { IStateManagerService, IStateObject } from '../../interfaces';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class SessionStateMock implements IStateManagerService {
    stateObservable<S extends ExtractionSelector<IStateObject>>(key: S): Observable<ExtractionResult<IStateObject, S>> {
        AlkLogger.info('SessionStateMock#stateObservable', 'key', key);
        return NEVER;
    }

    save<K extends keyof IStateObject>(key: K, value: IStateObject[K]): void {
        AlkLogger.info('SessionStateMock#save', 'key', key, 'value', value);
    }
}
